module.exports = __webpack_public_path__ + "img/racquet.9e831cb6.svg";